/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
import { createFromProvider } from '../Graph';
import { IProvider } from './IProvider';
/**
 * Facilitates create of new custom provider
 *
 * @export
 * @class SimpleProvider
 * @extends {IProvider}
 */
export class SimpleProvider extends IProvider {
    /**
     * Name used for analytics
     *
     * @readonly
     * @memberof IProvider
     */
    get name() {
        return 'MgtSimpleProvider';
    }
    constructor(getAccessTokenHandler, loginHandler, logoutHandler) {
        super();
        this._getAccessTokenHandler = getAccessTokenHandler;
        this._loginHandler = loginHandler;
        this._logoutHandler = logoutHandler;
        this.graph = createFromProvider(this);
    }
    /**
     * Invokes the getAccessToken function
     *
     * @param {AuthenticationProviderOptions} [options]
     * @returns {Promise<string>}
     * @memberof SimpleProvider
     */
    getAccessToken(options) {
        return this._getAccessTokenHandler(options === null || options === void 0 ? void 0 : options.scopes);
    }
    /**
     * Invokes login function
     *
     * @returns {Promise<void>}
     * @memberof SimpleProvider
     */
    login() {
        return this._loginHandler();
    }
    /**
     * Invokes logout function
     *
     * @returns {Promise<void>}
     * @memberof SimpleProvider
     */
    logout() {
        return this._logoutHandler();
    }
}
//# sourceMappingURL=SimpleProvider.js.map